import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

import offer1 from "../../img/Home/Offer/our1.webp";
import offer2 from "../../img/Home/Offer/our2.webp";
import offer3 from "../../img/Home/Offer/our3.webp";
import offer4 from "../../img/Home/Offer/our4.webp";
import nextButton from "../../img/nextb.svg";
import prevButton from "../../img/prevb.svg";
import Fade from 'react-reveal/Fade';

const offerSlides = [
  { image: offer1, titleKey: "offer.slide1.title", textKey: "offer.slide1.text" },
  { image: offer2, titleKey: "offer.slide2.title", textKey: "offer.slide2.text" },
  { image: offer3, titleKey: "offer.slide3.title", textKey: "offer.slide3.text" },
  { image: offer4, titleKey: "offer.slide4.title", textKey: "offer.slide4.text" },
];

function Offer() {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [swiper, setSwiper] = useState(null);

  return (
    <section className="bg-[#DAEBFC] xl:h-[434px]">
      <Fade bottom>
      <div className="relative mx-auto flex w-full max-w-[1220px] flex-col md:flex-row">
        <div className="order-2 flex min-h-[415px] w-full flex-col px-[20px] pb-[30px] pt-[25px] md:order-1 md:min-h-[252px] md:w-[50%] md:px-[46px] md:py-[48px] xl:px-[56px] xl:py-[52px]">
          <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273B4] md:text-[42px] xl:text-[40px]">
            {t("offer.title")}
          </h2>
          <span className="mt-[10px] block h-[4px] w-[106px] bg-[#05193A] md:w-[98px]" />

          <Swiper
            onSwiper={setSwiper}
            onSlideChange={(instance) => setActiveIndex(instance.realIndex)}
            className="mt-[20px] w-full md:mt-[20px]"
          >
            {offerSlides.map((slide) => (
              <SwiperSlide key={slide.titleKey}>
                <div className="max-w-[340px] xl:max-w-[360px]">
                  <h3 className="font-['Nunito_Sans'] text-[20px] font-black leading-[1.5] text-[#05193A] md:text-[21px]">
                    {t(slide.titleKey)}
                  </h3>
                  <p className="mt-[22px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193A] md:mt-[10px] md:text-[16px]">
                    {t(slide.textKey)}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="order-1 h-[190px] w-full overflow-hidden md:order-2 md:h-auto">
          <img
            key={offerSlides[activeIndex].image}
            src={offerSlides[activeIndex].image}
            alt={t(offerSlides[activeIndex].titleKey)}
            className="xl:h-[434px] w-full animate-[offer-image-in_500ms_ease-out] object-cover"
          />
        </div>

        <div className="absolute bottom-[32px] left-[20px] z-10 flex items-center gap-[12px] md:bottom-[46px] md:left-[46px] xl:bottom-[52px] xl:left-[56px]">
          <div className="flex items-center gap-[10px]">
            {offerSlides.map((slide, index) => (
              <button
                key={slide.titleKey}
                type="button"
                aria-label={t("offer.goTo", { number: index + 1 })}
                onClick={() => swiper?.slideTo(index)}
                className={`h-px w-[52px] transition-colors md:h-[4px] md:w-[65px] ${index === activeIndex ? "bg-[#05193A]" : "bg-[#05193A33]"}`}
              />
            ))}
          </div>
        </div>

        <div className="absolute bottom-[35px] right-[20px] z-10 flex items-center gap-[10px] xl:bottom-[45px] xl:left-[470px] xl:right-auto">
          <button type="button" aria-label={t("offer.previous")} onClick={() => swiper?.slidePrev()}>
            <img src={prevButton} alt="" className="h-[42px] w-[42px]" />
          </button>
          <button type="button" aria-label={t("offer.next")} onClick={() => swiper?.slideNext()}>
            <img src={nextButton} alt="" className="h-[42px] w-[42px]" />
          </button>
        </div>
      </div>
      </Fade>
    </section>
  );
}

export default Offer;
